/**
 * Configuración centralizada para el encapsulamiento CSS
 * Estas constantes se utilizan a lo largo de la aplicación para asegurar consistencia
 * en el encapsulamiento de estilos
 */

export const WRAPPER_CLASS = "footerv2-wrapper";
export const APP_CLASS = "footerv2";
export const MODAL_CLASS = "footerv2-modal";
export const POPOVER_CLASS = "footerv2-popover";